/* ============================================================
   ELANOVIE THEME · JavaScript
   Cart, mobile menu, product gallery, tabs, accordions
   No external dependencies.
   ============================================================ */

(function () {
  'use strict';

  /* ── UTILITY ── */
  function $(selector, scope) { return (scope || document).querySelector(selector); }
  function $$(selector, scope) { return Array.from((scope || document).querySelectorAll(selector)); }

  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    }, opts || {})).then(function (r) {
      if (!r.ok) return r.json().then(function (data) { throw data; });
      return r.json();
    });
  }

  /* ── TOAST ── */
  function showToast(message, type) {
    var container = $('#toast-container');
    if (!container) return;
    var toast = document.createElement('div');
    toast.className = 'toast' + (type ? ' toast--' + type : '');
    toast.textContent = message;
    container.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.remove(); }, 400);
    }, 3500);
  }

  /* ── MOBILE MENU ── */
  function initMobileMenu() {
    var toggle = $('[data-mobile-toggle]');
    var menu = $('[data-mobile-menu]');
    var overlay = $('[data-mobile-overlay]');
    var close = $('[data-mobile-close]');
    if (!toggle || !menu) return;

    function open() {
      menu.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      menu.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);
    $$('a', menu).forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
  }

  /* ── CART DRAWER ── */
  var cartDrawer = {
    el: null, overlay: null,

    init: function () {
      this.el = $('[data-cart-drawer]');
      this.overlay = $('#cart-overlay');
      if (!this.el) return;

      var self = this;
      $$('[data-cart-open]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          self.open();
        });
      });
      var closeBtn = $('[data-cart-close]', this.el);
      if (closeBtn) closeBtn.addEventListener('click', function () { self.close(); });
      if (this.overlay) {
        this.overlay.addEventListener('click', function () { self.close(); });
      }

      this.bindItemActions();
    },

    bindItemActions: function () {
      var self = this;
      this.el.addEventListener('click', function (e) {
        var target = e.target;
        var qtyBtn = target.closest('[data-qty-btn]');
        var removeBtn = target.closest('[data-cart-remove]');
        if (qtyBtn) {
          e.preventDefault();
          var line = qtyBtn.dataset.line;
          var direction = qtyBtn.dataset.qtyBtn;
          var input = qtyBtn.parentElement.querySelector('input');
          var current = parseInt(input.value, 10) || 0;
          var next = direction === 'plus' ? current + 1 : Math.max(0, current - 1);
          self.updateLine(line, next);
        }
        if (removeBtn) {
          e.preventDefault();
          self.updateLine(removeBtn.dataset.line, 0);
        }
      });
    },

    open: function () {
      this.refresh();
      this.el.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },

    close: function () {
      this.el.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    },

    refresh: function () {
      var self = this;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); })
        .catch(function () { /* fail silently */ });
    },

    render: function (cart) {
      var itemsEl = $('[data-cart-items]', this.el);
      var subtotalEl = $('[data-cart-subtotal]', this.el);
      var footer = $('[data-cart-footer]', this.el);
      var emptyEl = $('[data-cart-empty]', this.el);
      if (!itemsEl) return;

      if (cart.item_count === 0) {
        itemsEl.innerHTML = '';
        if (emptyEl) emptyEl.style.display = 'block';
        if (footer) footer.style.display = 'none';
      } else {
        if (emptyEl) emptyEl.style.display = 'none';
        if (footer) footer.style.display = '';
        var html = cart.items.map(function (item, index) {
          var line = index + 1;
          var img = item.image
            ? '<img src="' + item.image + '" alt="' + escapeAttr(item.title) + '" class="cart-item__image">'
            : '<div class="cart-item__image"></div>';
          var variant = item.variant_title && item.variant_title !== 'Default Title'
            ? '<div class="cart-item__variant">' + escapeHTML(item.variant_title) + '</div>' : '';
          return ''
            + '<div class="cart-item">'
            + img
            + '<div>'
            +   '<div class="cart-item__title">' + escapeHTML(item.product_title) + '</div>'
            +   variant
            +   '<div class="cart-item__qty">'
            +     '<button type="button" data-qty-btn="minus" data-line="' + line + '" aria-label="Decrease quantity">−</button>'
            +     '<input type="text" value="' + item.quantity + '" readonly>'
            +     '<button type="button" data-qty-btn="plus" data-line="' + line + '" aria-label="Increase quantity">+</button>'
            +   '</div>'
            +   '<button type="button" class="cart-item__remove" data-cart-remove data-line="' + line + '">Remove</button>'
            + '</div>'
            + '<div class="cart-item__price-col">'
            +   '<div class="cart-item__price">' + formatMoney(item.line_price) + '</div>'
            + '</div>'
            + '</div>';
        }).join('');
        itemsEl.innerHTML = html;
      }
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      var countEl = $('[data-cart-count]');
      if (countEl) countEl.textContent = cart.item_count;
    },

    add: function (id, quantity) {
      var self = this;
      return fetchJSON(window.Elanovie.routes.cart_add_url, {
        method: 'POST',
        body: JSON.stringify({ id: id, quantity: quantity || 1 })
      }).then(function () {
        self.refresh();
        self.open();
        showToast('Added to your bag', 'success');
      }).catch(function (err) {
        showToast((err && err.description) || 'Could not add to bag');
      });
    },

    updateLine: function (line, qty) {
      var self = this;
      return fetchJSON(window.Elanovie.routes.cart_change_url, {
        method: 'POST',
        body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
      }).then(function (cart) {
        self.render(cart);
      }).catch(function () {
        self.refresh();
      });
    }
  };

  function escapeHTML(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHTML(s); }

  /* ── ADD TO CART (PRODUCT PAGE) ── */
  function initAddToCart() {
    $$('[data-add-to-cart]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var idInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        if (!idInput) return;
        if (btn) { btn.disabled = true; btn.dataset.originalText = btn.textContent; btn.textContent = 'Adding…'; }
        cartDrawer.add(idInput.value, qtyInput ? parseInt(qtyInput.value, 10) : 1)
          .finally(function () {
            if (btn) { btn.disabled = false; btn.textContent = btn.dataset.originalText || 'Add to bag'; }
          });
      });
    });
  }

  /* ── PRODUCT GALLERY ── */
  function initProductGallery() {
    $$('[data-gallery]').forEach(function (gallery) {
      var main = $('[data-gallery-main]', gallery);
      var thumbs = $$('[data-gallery-thumb]', gallery);
      if (!main || thumbs.length === 0) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          var fullSrc = thumb.dataset.full || thumb.querySelector('img').src;
          var img = main.querySelector('img');
          if (img) { img.src = fullSrc; }
        });
      });
    });
  }

  /* ── VARIANT SELECTOR ── */
  function initVariantSelector() {
    $$('[data-variant-selector]').forEach(function (form) {
      var product = form.dataset.product ? JSON.parse(form.dataset.product) : null;
      if (!product) return;
      var idInput = form.querySelector('[name="id"]');
      var priceNew = form.querySelector('[data-price-new]');
      var priceOld = form.querySelector('[data-price-old]');
      var btn = form.querySelector('[type="submit"]');

      function getSelectedValues() {
        var values = [];
        $$('[data-option-position]', form).forEach(function (group) {
          var active = group.querySelector('.is-active');
          values.push(active ? active.dataset.value : null);
        });
        return values;
      }

      function update() {
        var selected = getSelectedValues();
        var variant = product.variants.find(function (v) {
          return selected.every(function (val, i) { return val === null || v['option' + (i+1)] === val; });
        });
        if (variant) {
          if (idInput) idInput.value = variant.id;
          if (priceNew) priceNew.textContent = formatMoney(variant.price);
          if (priceOld) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              priceOld.textContent = formatMoney(variant.compare_at_price);
              priceOld.style.display = '';
            } else {
              priceOld.style.display = 'none';
            }
          }
          if (btn) {
            if (variant.available) {
              btn.disabled = false;
              btn.textContent = window.Elanovie.strings.addToCart || 'Add to bag';
            } else {
              btn.disabled = true;
              btn.textContent = window.Elanovie.strings.soldOut || 'Sold out';
            }
          }
        }
      }

      $$('[data-option-position] [data-value]', form).forEach(function (opt) {
        opt.addEventListener('click', function (e) {
          e.preventDefault();
          var group = opt.closest('[data-option-position]');
          $$('[data-value]', group).forEach(function (o) { o.classList.remove('is-active'); });
          opt.classList.add('is-active');
          update();
        });
      });

      update();
    });
  }

  /* ── PRODUCT TABS ── */
  function initProductTabs() {
    $$('[data-tabs]').forEach(function (tabs) {
      var btns = $$('[data-tab-btn]', tabs);
      var panels = $$('[data-tab-panel]', tabs);
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var tabName = btn.dataset.tabBtn;
          btns.forEach(function (b) { b.classList.remove('is-active'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var panel = panels.find(function (p) { return p.dataset.tabPanel === tabName; });
          if (panel) panel.classList.add('is-active');
        });
      });
    });
  }

  /* ── QUANTITY INPUT ── */
  function initQtyInputs() {
    $$('[data-qty-input]').forEach(function (wrapper) {
      var input = wrapper.querySelector('input');
      var minus = wrapper.querySelector('[data-qty="minus"]');
      var plus = wrapper.querySelector('[data-qty="plus"]');
      if (!input) return;
      if (minus) {
        minus.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          input.value = Math.max(1, v - 1);
        });
      }
      if (plus) {
        plus.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          input.value = v + 1;
        });
      }
    });
  }

  /* ── NEWSLETTER ── */
  function initNewsletter() {
    $$('[data-newsletter-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        // allow the native Shopify submission to happen but show a friendly state
        var successEl = form.parentElement.querySelector('[data-newsletter-success]');
        if (successEl) {
          setTimeout(function () {
            successEl.classList.add('is-visible');
          }, 100);
        }
      });
    });
  }

  /* ── SMOOTH SCROLL FOR ANCHORS ── */
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      var href = anchor.getAttribute('href');
      if (href === '#' || href === '#0') return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  /* ── EDITORIAL PRODUCT STICKY BAR ── */
  function initEditorialProductSticky() {
    var bar = $('[data-sticky-product]');
    var hero = $('[data-product-hero]');
    if (!bar || !hero) return;

    function update() {
      var threshold = hero.offsetTop + (hero.offsetHeight * 0.4);
      if (window.scrollY > threshold) {
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
      }
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  /* ── INIT ── */
  function init() {
    initMobileMenu();
    cartDrawer.init();
    initAddToCart();
    initProductGallery();
    initVariantSelector();
    initProductTabs();
    initQtyInputs();
    initNewsletter();
    initSmoothScroll();
    initEditorialProductSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose for external use
  window.Elanovie = window.Elanovie || {};
  window.Elanovie.cart = cartDrawer;
  window.Elanovie.toast = showToast;

})();
